// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-17a667df]{margin-top:36px;margin-bottom:24px}h1[data-v-17a667df]{font-size:16px;font-weight:500;line-height:1.5;color:#141c20;margin-bottom:16px}p[data-v-17a667df]{font-size:14px;line-height:1.21;color:#54626c;margin-bottom:30px}.btn[data-v-17a667df]{margin-top:0!important;margin-bottom:36px!important;padding:6px 16px!important;font-size:14px!important;font-weight:500!important;line-height:1.2!important;color:#fff!important}", ""]);
// Exports
module.exports = exports;
